import { Autocomplete, Checkbox, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useState } from "react";
import { font } from "../../../styles/font";
import {  TextFieldMA } from "../../../styles/styledComponents";
import { theme } from "../../../styles/theme";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { ButtonCustom } from "../../button";
import { updateDetails } from "../../../api/controllers/userController";
import { HttpStatusCode } from "axios";
import { ApplicationContext } from "../../../context/application_ctx";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
export const CompanyProfile = ({ setLoginNavigation }) => {
  const { tokenTemp } = useContext(ApplicationContext);
  const [profileDetails, setProfileDetails] = useState({
    companyName: null,
    companyAddress: null,
    companyUrl: null,
    companyRegistrationNumber: null,
    vatRegistrationNumber: null,
    companyKeywords: null,
    numberOfEmployees: null,
    companyDescription: null,
    legalStatus: undefined,
  });
  const [markAsOptional] = useState(false);
  const [loaderState, setLoaderState] = useState(false);

  const legalStatusList = [
    { title: "Chartable Incorporated Company (CIO)", id:0 },
    { title: "Communty Interest Company (CIC)", id:1 },
    { title: "General Patnership", id:2 },
    { title: "Industrial & Provident Society", id:3 },
    { title: "Limited Liability Partnership (LLP)", id:4 },
    { title: "Linted Pameship", id:5 },
    { title: "Private Company Limted by Guarantee (LTD)", id:6 },
    { title: "Private Limited Company (LTD)", id:7 },
    { title: "Public Limied Company (PLC)", id:8 },
    { title: "Sole Trader", id:9 },
    { title: "Unlimited Company", id:10 },
    { title: "other", id:11 },
  ];

  console.log(profileDetails);

  const handleDetails = async () => {
    // setLoginNavigation(3);

    // setLoginNavigation(3);
    // setLoaderState(true)
    if (profileDetails.companyName === null) {
      profileDetails.companyName = "";
    }
    if (profileDetails.companyAddress === null) {
      profileDetails.companyAddress = "";
    }
    if (profileDetails.companyKeywords === null) {
      profileDetails.companyKeywords = "";
    }
    // if (profileDetails.companyRegistrationNumber === null) {
    //   profileDetails.companyRegistrationNumber = "";
    // }
    // if (profileDetails.vatRegistrationNumber === null) {
    //   profileDetails.vatRegistrationNumber = "";
    // }
    if (!profileDetails.legalStatus) {
      profileDetails.legalStatus = null;
    }
    if (!profileDetails.numberOfEmployees) {
      profileDetails.numberOfEmployees = "";
    }
    // if (!profileDetails.companyDescription && !markAsOptional) {
    //   profileDetails.companyDescription = "";
    // }
    setProfileDetails({ ...profileDetails });
    if (
      profileDetails.companyName &&
      profileDetails.companyAddress &&
      profileDetails.companyKeywords &&
      // profileDetails.companyRegistrationNumber &&
      // profileDetails.vatRegistrationNumber &&
      profileDetails.legalStatus &&
      profileDetails.numberOfEmployees
    ) {
      if (profileDetails.companyDescription || markAsOptional) {
        console.log("yes ready to send");
        profileDetails.legalStatus = profileDetails?.legalStatus?.title;
        try {
          let response = await updateDetails(profileDetails, tokenTemp);
          console.log(response, "responseLogin");
          if (response.status === HttpStatusCode.Ok) {
            setLoaderState(false);
            setLoginNavigation(3);

            // setError(response.data.message);
            // setSignInSnack(true);
            // setTimeout(() => {
            //   setSignInSnack(false);
            // }, 3000);
            //   setLoaderState(false);

            //   localStorage.setItem("api-token", response.data.token);
            //   navigate("/admin-dashboard");
          }
          if (response.status === HttpStatusCode.BadRequest) {
            //   setLoaderState(false);
            //   setError(response.data.message);
            //   setSignInSnack(true);
            //   setTimeout(() => {
            //     setLoginNavigation(1);
            //     setSignInSnack(false);
            //   }, 3000);
          }
          if (response.status === HttpStatusCode.Unauthorized) {
            //   setLoaderState(false);
            //   setError(response.data.message);
            //   setSignInSnack(true);
            //   setTimeout(() => {
            //     setSignInSnack(false);
            //   }, 3000);
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  console.log(profileDetails, "profileDetails");


  return (
    <>
      <Box
        display={"flex"}
        width="78%"
        height={"100%"}
        gap="14px"
        overflow="auto"
        flexDirection="column"
        paddingRight="12px"
        // alignItems="center"
        // justifyContent='center'
      >
        <Typography
          fontSize={font.size.fs_2}
          color={theme.col_3}
          fontFamily={font.family.fm_2}
          fontWeight="bold"
          //   position="sticky"
          //   top="0px"
          sx={{ backdropFilter: "blur(50px)" }}
        >
          Please provide details about to your company
        </Typography>

        <Box
          display={"flex"}
          width="100%"
          gap="15px"
          // height={"25px"}
          flexDirection="column"
          // alignItems="center"
        >
          <Typography
            padding="6px 6px 6px 11px"
            backgroundColor={theme.col_3_alpha}
            borderRadius="6px"
            fontSize={font.size.fs_6}
            color={theme.col_3}
            fontFamily={font.family.fm_2}
            fontWeight="bold"
          >
            Company Info
          </Typography>
          <Box
            display={"flex"}
            width="100%"
            gap="15px"
            // height={"25px"}
            // alignItems="center"
          >
            <TextFieldMA
              size="small"
              required
              error={
                profileDetails.companyName === null
                  ? false
                  : profileDetails.companyName === ""
                  ? true
                  : false
              }
              helperText={
                profileDetails.companyName === null
                  ? ""
                  : profileDetails.companyName === ""
                  ? "Company name is required"
                  : ""
              }
              onBlur={(e) =>
                setProfileDetails({
                  ...profileDetails,
                  companyName: e.target.value,
                })
              }
              fullWidth
              label="Company Name"
            />
            <TextFieldMA
              size="small"
              required
              error={
                profileDetails.companyAddress === null
                  ? false
                  : profileDetails.companyAddress === ""
                  ? true
                  : false
              }
              helperText={
                profileDetails.companyAddress === null
                  ? ""
                  : profileDetails.companyAddress === ""
                  ? "Company address is required"
                  : ""
              }
              onBlur={(e) =>
                setProfileDetails({
                  ...profileDetails,
                  companyAddress: e.target.value,
                })
              }
              fullWidth
              label="Company Address"
            />
          </Box>
          <Box
            display={"flex"}
            width="100%"
            gap="15px"
            // height={"25px"}
            // alignItems="center"
          >
            <TextFieldMA
              size="small"
              //   required
              //   error={
              //     profileDetails.companyUrl === null
              //       ? false
              //       : profileDetails.companyUrl === ""
              //       ? true
              //       : false
              //   }
              //   helperText={
              //     profileDetails.companyUrl === null
              //       ? ""
              //       : profileDetails.companyUrl === ""
              //       ? "Company URL is required"
              //       : ""
              //   }
              onBlur={(e) =>
                setProfileDetails({
                  ...profileDetails,
                  companyUrl: e.target.value,
                })
              }
              fullWidth
              label="Company URL"
            />
            <TextFieldMA
              size="small"
              // required
              // error={
              //   profileDetails.companyRegistrationNumber === null
              //     ? false
              //     : profileDetails.companyRegistrationNumber === ""
              //     ? true
              //     : false
              // }
              // helperText={
              //   profileDetails.companyRegistrationNumber === null
              //     ? ""
              //     : profileDetails.companyRegistrationNumber === ""
              //     ? "Company register no is required"
              //     : ""
              // }
              onBlur={(e) =>
                setProfileDetails({
                  ...profileDetails,
                  companyRegistrationNumber: e.target.value,
                })
              }
              fullWidth
              label="Company Registration No"
            />
          </Box>
          <TextFieldMA
            size="small"
            // required
            // error={
            //   profileDetails.vatRegistrationNumber === null
            //     ? false
            //     : profileDetails.vatRegistrationNumber === ""
            //     ? true
            //     : false
            // }
            // helperText={
            //   profileDetails.vatRegistrationNumber === null
            //     ? ""
            //     : profileDetails.vatRegistrationNumber === ""
            //     ? "Company VAT no is required"
            //     : ""
            // }
            onBlur={(e) =>
              setProfileDetails({
                ...profileDetails,
                vatRegistrationNumber: e.target.value,
              })
            }
            fullWidth
            label="VAT Registration No"
          />
        </Box>
        <Box
          display={"flex"}
          width="100%"
          gap="15px"
          // height={"25px"}
          flexDirection="column"
          // alignItems="center"
        >
          <Typography
            padding="6px 6px 6px 11px"
            backgroundColor={theme.col_3_alpha}
            borderRadius="6px"
            fontSize={font.size.fs_6}
            color={theme.col_3}
            fontFamily={font.family.fm_2}
            fontWeight="bold"
          >
            Company Description
          </Typography>

          <TextFieldMA
            size="small"
            required
            error={
              profileDetails.companyKeywords === null
                ? false
                : profileDetails.companyKeywords === ""
                ? true
                : false
            }
            helperText={
              profileDetails.companyKeywords === null
                ? ""
                : profileDetails.companyKeywords === ""
                ? "Company keywords is required"
                : ""
            }
            onBlur={(e) =>
              setProfileDetails({
                ...profileDetails,
                companyKeywords: e.target.value,
              })
            }
            fullWidth
            label="Company Keywords"
          />
          <TextFieldMA
            size="small"
            required
            type="number"
            error={
              profileDetails.numberOfEmployees === null
                ? false
                : profileDetails.numberOfEmployees === ""
                ? true
                : false
            }
            helperText={
              profileDetails.numberOfEmployees === null
                ? ""
                : profileDetails.numberOfEmployees === ""
                ? "No of employee is required"
                : ""
            }
            onBlur={(e) =>
              setProfileDetails({
                ...profileDetails,
                numberOfEmployees: e.target.value,
              })
            }
            fullWidth
            label="Number of Employees"
          />
          <Box
            display={"flex"}
            width="100%"
            gap="6px"
            // height={"25px"}
            flexDirection="column"
            // alignItems="center"
          >
            {/* <Box
              display={"flex"}
              width="100%"
              gap="2px"
              // height={"25px"}
              flexDirection="column"
              // alignItems="center"
            >
              <Typography
                fontSize={font.size.fs_4}
                color={theme.col_2}
                fontFamily={font.family.fm_2}
                fontWeight="bold"
              >
                Description
              </Typography>
              <Typography
                fontSize={font.size.fs_4}
                color={theme.col_6}
                fontFamily={font.family.fm_2}
                fontWeight="bold"
              >
                We require all this information to create your workgroup unless
                marked as (optional)
              </Typography>
            </Box> */}
            <TextFieldMA
              size="small"
              // required={!markAsOptional}
              multiline
              maxRows={4}
              // error={
              //   markAsOptional
              //     ? false
              //     : profileDetails.companyDescription === null
              //     ? false
              //     : profileDetails.companyDescription === ""
              //     ? true
              //     : false
              // }
              // helperText={
              //   markAsOptional
              //     ? ""
              //     : profileDetails.companyDescription === null
              //     ? ""
              //     : profileDetails.companyDescription === ""
              //     ? "Company description is required"
              //     : ""
              // }
              onBlur={(e) =>
                setProfileDetails({
                  ...profileDetails,
                  companyDescription: e.target.value,
                })
              }
              fullWidth
              label="Company Description"
            />
            {/* <Box
              display="flex"
              width="30%"
              height={"15px"}
              // flex={1}
              alignItems="center"
              onClick={() => setMarkAsOptional(!markAsOptional)}
            >
              <Typography
                fontSize={font.size.fs_4}
                fontFamily={font.family.fm_2}
                color={theme.col_3}
              >
                Mark as optional
              </Typography>
              <CheckboxMA checked={markAsOptional} />
            </Box> */}
          </Box>
          <Box
            display={"flex"}
            width="100%"
            gap="6px"
            // height={"25px"}
            flexDirection="column"
            // alignItems="center"
          >
            {/* <Box
              display={"flex"}
              width="100%"
              gap="2px"
              // height={"25px"}
              flexDirection="column"
              // alignItems="center"
            >
              <Typography
                fontSize={font.size.fs_4}
                color={theme.col_2}
                fontFamily={font.family.fm_2}
                fontWeight="bold"
              >
                legalStatus
              </Typography>
              <Typography
                fontSize={font.size.fs_4}
                color={theme.col_6}
                fontFamily={font.family.fm_2}
                fontWeight="bold"
              >
                Please check all that apply. This information is used for
                reporting purposes only
              </Typography>
            </Box> */}
            <Autocomplete
              size="small"
              fullWidth
              //   multiple
              onChange={(event, newValue) => {
                // console.log(newValue);
                setProfileDetails({ ...profileDetails, legalStatus: newValue });
                //  setlegalStatus(newValue)
              }}
              isOptionEqualToValue={(option, val) => option.id === val.id}
              value={profileDetails.legalStatus}
              //   inputValue={inputValue}
              //   onInputChange={(event, newInputValue) => {
              //     console.log(newInputValue);
              //   }}
              id="checkboxes-tags-demo"
              options={legalStatusList}
              disableCloseOnSelect
              getOptionLabel={(option) => option.title}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    // checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.title}
                </li>
              )}
              //   style={{ width: 500 }}
              renderInput={(params) => (
                <TextFieldMA
                  size="small"
              required

                  fullwidth
                  error={profileDetails.legalStatus === null ? true : false}
                  helperText={
                    profileDetails.legalStatus === null
                      ? "Job Title is required"
                      : ""
                  }
                  {...params}
                  label="Legal Status of Company"
                  placeholder="Legal Statuses"
                />
              )}
            />
          </Box>
          {/* <TextFieldMA
            size="small"
            required
            // error={
            //   email === null
            //     ? false
            //     : !validator.isEmail(email) && email !== ""
            //     ? true
            //     : email === ""
            //     ? true
            //     : false
            // }
            // helperText={
            //   email === null
            //     ? ""
            //     : !validator.isEmail(email) && email !== ""
            //     ? "Enter valid email"
            //     : email === ""
            //     ? "Email is required"
            //     : ""
            // }
            // onBlur={(e) => setEmail(e.target.value)}
            fullWidth
            label="legalStatus"
          /> */}
        </Box>
        <Box display="flex" justifyContent="flex-end">
          <ButtonCustom
            onClick={handleDetails}
            fullWidth={false}
            width="90px"
            disabled={loaderState}
            loaderState={loaderState}
            // borderRadius="42px"
            // size="large"
            background={theme.col_2}
            backgroundRipple={theme.col_3}
            focusColor={theme.col_1}
            display="flex"
            alignItems="center"
            justifyContent="center"
            typography={
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                // fontWeight="bold"
                color={theme.col_4}
              >
                Next
              </Typography>
            }
          />
        </Box>
      </Box>
    </>
  );
};
